/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {formatoFechaTabla} from "../../../Utilidades/formatoFechaTabla";

const Casilla_Fecha_Dato = ({fecha, dato, dir ,index}) => {

    return (
        <TableCell key={`${index}dato`} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontWeight: 600, fontSize: 14, minWidth: 160}}>
            <Grid container size={12} alignItems={'center'}>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 12}}>
                            {formatoFechaTabla(fecha)}
                        </Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>
                            {dato}
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </TableCell>

    )

}
export default Casilla_Fecha_Dato